import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alert, confirm, custom } from 'devextreme/ui/dialog';
import { RentriService } from '../../services/rentri.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';
import { Apiservice } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaMaster } from '../nica-master-component/nica-master.component';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';


var currentThis;
@Component({
  selector: 'app-registririfiuti',
  templateUrl: './registririfiuti.component.html',
  styleUrls: ['./registririfiuti.component.css']
})
export class RegistririfiutiComponent extends NicaMaster implements OnInit {
  @ViewChild('registriCaricoScarico', { static: false }) registriCaricoScarico: NicaAnagraficaComponent;

  panelTitle="Registri di C/S Rifiuti"
  navigation;
  params;
  idSedeRentri;
  elencoRegistriRentri;
  idSedeUL;
  titoloRegistri="Elenco Registri R.E.N.T.Ri." ;
  popupComponentVisible;
  elencoRegistriFilter
  help=undefined; //"HELP%20RENTRINCLOUD.html"

  constructor( private activateRoute:ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice:Apiservice,
    

    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    private changeDetector: ChangeDetectorRef

     ) {
      super(
        userComponentService,
        templateService,
        _overlaySideFormService,
        _overlaySidePanelService,
        formTemplateService,
        _componentFactoryResolver,
        activatedroute,
        router,
        menuService,
        rentriService,
        anagraficaService,
  
      );
    }
  
  
 
onShowing(){

}
chiudiPopup(e){
  this.popupComponentVisible=false;
  }
  ngOnInit() {
    var currentThis=this;
    this.activateRoute.queryParams.subscribe(params=>{
      this.params=params
      if(this.params.help){
        this.help=this.params.help;
      }else{
        this.help='ConfigurazioneRegistridiCaricoeS.html';
      }
      
      console.log("Parametri=",this.params);   

     
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName



          this.setGlobalVariableFromParams(params);
   

    })
  }
  validateDataFieldPrepared(e:any){
    console.log("In prepared ",e);
   
  }
  LeggiElencoRegistriRentri(e){
    this.registriCaricoScarico.settaField('registroRentri2','')
    this.rentriService.loginRentriSede(this.idSedeUL).then(res => {
      if (res) {
          this.elencoRegistriFilter='?IdentificativoStruttura='+this.idSedeRentri
         //this.popupComponentVisible=true;
          this.rentriService.getRegistri(this.idSedeRentri).then(res => {          
          this.elencoRegistriRentri=res
            console.log('Ecco i registri ',this.elencoRegistriRentri)
                     
            if(e.data && e.data.registroRentri>''){
              var x;
              x=this.elencoRegistriRentri.find(el=>{return el.identificativo==e.data.registroRentri })
              setTimeout(() => {
              if(x)             
               this.registriCaricoScarico.settaField('registroRentri2',x.attivitaRegistroDesc)
              else
              this.registriCaricoScarico.settaField('registroRentri2','')
              }, 0);
             // if(x) 
               //   this.registriCaricoScarico.settaHelp('registroRentri',x.attivitaRegistroDesc)
              
            }
          })
        }
      })
  }
  
AllEvent(e:any,campo:any){
  console.log("NAMEEEEEEEEEEEEEEEEEEEEEEEEE ",e.name);
if(e.dataField=='per')
{
console.log("NAMEEEEEEEEEEEEEEEEEEEEEEEEE ",e.name);
  console.log("NAMEEEEEEEEEEEEEEEEEEEEEEEEE ",e);
}
//onInitNewRow
//onEditorPrepared

//
if(e.name=='setCellValue'){
  console.log("VALOREEEEEEEEEEEEEEEEEEEEEEEE ",e);
  if(e.dataField=="idSede"){
    if(e.value==null){

      
      this.idSedeRentri=null;
      this.idSedeUL=null;
      this.registriCaricoScarico.settaField(['registroRentri','registroRentri2'],'')  
      //this.registriCaricoScarico.settafield('registroRentri2','')  
      //console.log("campoooooooooooooooooo ",e.masterThis.colonnePerField[e.dataField])
    }
  }
  //onInitNewRow 
}

if(e.name=='AssociaRegistroRentri_clear'){
  this.registriCaricoScarico.settaField('registroRentri','')
  this.registriCaricoScarico.settaField('registroRentri2','')
  
}

if(e.name=='onEditorPrepared'){
  console.log('onEditorPrepared ',e)
  if(e.data.assegnaProtocolloInRegistrazione==true)
    this.registriCaricoScarico.settaField('assegnaProtocollo','R')
  else
  this.registriCaricoScarico.settaField('assegnaProtocollo','S')

  //controllo isMovimentato
  setTimeout(() => {
    if(e.data.isMovimentato==true){
      this.registriCaricoScarico.changeStateField(['idSede','registroRentri','assegnaProtocollo'],true)
  }
  //isMovimentatoRentri
  if(e.data.isStampato==true){
    this.registriCaricoScarico.changeStateField(['numeroUltimoProtocollo','dataUltimoProtocolloStampato'],true)
}
}, 10);
  



 //this.registriCaricoScarico.settaField('assegnaProtocolloInFaseDiStampaDefinitiva',true)
 this.apiservice.GetApi('Sede?id='+e.data.idSede).then(res=>{
  if(res){
    this.idSedeRentri=res['idSedeRentri']
    this.idSedeUL=res['id']
    this.LeggiElencoRegistriRentri(e);
    
  }
    
  })
}

if (e.name == 'AssociaRegistroRentri') {
  if(!this.idSedeUL) return;
 
  //this.myDSdisbleField[prog]
 
  console.log("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww ")


  this.rentriService.loginRentriSede(this.idSedeUL).then(res => {
    if (res) {
        this.elencoRegistriFilter='?IdentificativoStruttura='+this.idSedeRentri
        this.popupComponentVisible=true;

      this.rentriService.getRegistri(this.idSedeRentri).then(res => {
        console.log("Ecco i registri ",res)
        //this.registriCaricoScarico.CaricaDS

      })

      let titleDynamic = "Registri R.E.N.T.R.i"
      let componentData = {
        type: 'campoSpecial',
        dataField: "idSedeRentri",
        dynamic: {
          dataSource: "RentriOld/getRegistri",
          service: "serviceRentriRegistriElenco",
          valueExpr: 'registroRentri',
          displayExpr: '',
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          enableEditor: false,
          buttonOption: {
            event: ''
          },
          caption:'Elenco Registri R.E.N.T.Ri',
          settingGrid: {
            campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
            masterKey: 'identificativo',
            keyUnique: 'identificativo',
            selectionMode: 'single',
            rowAlternationEnabled: true,
            repaintChangesOnly: false,
            remoteOperations: true,
            hoverStateEnabled: true,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            searchAndSelect: false,
            searchAndSelectDataSource: '',
            bottoniSottoGriglia:false,
            height:450
          }
        }
      }
      //this.formSoggetto.eventmitter(componentData, e.event, 'dynamicGrid', 'RentriOld/getRegistri', titleDynamic)
    } else {
      alert('Nessuna Configurazione', 'Attenzione!')
    }
  })

}

if(e.name == 'selezionaRegistro'){

  
if(e.componentName=='elencoRegistriRentri')
{
  this.chiudiPopup(null);
  this.spinner.show();
  setTimeout(() => { 
   this.registriCaricoScarico.settaField('registroRentri',e.row.data.identificativo);
   this.registriCaricoScarico.settaField('registroRentri2',e.row.data.attivitaRegistroDesc)
   this.spinner.hide();
  }, 200);
}  
 
  return;
}

if(e.name=='onSelectionChanged'){
  //alert('onSelectionChanged','onSelectionChanged')

if(e.componentName=='elencoRegistriRentri')
{
  this.chiudiPopup(null);
  this.spinner.show();
  setTimeout(() => {  
   this.registriCaricoScarico.settaField('registroRentri',e.data.identificativo);
   this.registriCaricoScarico.settaField('registroRentri2',e.data.attivitaRegistroDesc)
   this.spinner.hide();
  }, 200);
   
   
}

}   

if(e.name=="onRowClickLookUp"){
  if(e.data.idSedeRentri)
   this.idSedeRentri=e.data.idSedeRentri;
   if(e.data.id && e.dataField=="idSede"){
    this.idSedeUL=e.data.id;
    //console.log("Adesso azzero Field registroRentri ",e)
    this.registriCaricoScarico.settaField('registroRentri','')
    this.registriCaricoScarico.settaField('registroRentri2','')
   }
 
}


if(e.name=="onInitNewRow"){
   this.registriCaricoScarico.settaField('registroRentri2','')
   this.registriCaricoScarico.settaField('assegnaProtocolloInRegistrazione',false)
   this.registriCaricoScarico.settaField('assegnaProtocolloInFaseDiStampaDefinitiva',true)
   this.registriCaricoScarico.settaField('assegnaProtocollo','S')

 
  return e;
}
    if(e.name=="onSaving"){
      console.log("STO SALVANDO ",e.changes);
      if(e.changes){
        if(e.changes[0].data.assegnaProtocollo){
          e.changes[0].data.assegnaProtocolloInRegistrazione=false;
          e.changes[0].data.assegnaProtocolloInFaseDiStampaDefinitiva=false;
          if(e.changes[0].data.assegnaProtocollo=='S')
            e.changes[0].data.assegnaProtocolloInFaseDiStampaDefinitiva=true; else
            e.changes[0].data.assegnaProtocolloInRegistrazione=true
        }
      }
      //e.cancel=true;
      //return;
      // Prima di Salvare i dati controllo se esiste gia un registro associato rentri

      /*
"assegnaProtocolloInRegistrazione": true,
  "assegnaProtocolloInFaseDiStampaDefinitiva": true,
      */


      


      //let valueCer=e.changes[0].codiceCER;
      if(e.changes && e.changes[0].data.numeroUltimoProtocollo){
        let cc=parseInt(e.changes[0].data.numeroUltimoProtocollo);
        cc=cc>=0 ? cc*1:cc=cc*-1
        //e.changes[0].data.numeroUltimoProtocollo=e.changes[0].data.numeroUltimoProtocollo.abs().toString();
        e.changes[0].data.numeroUltimoProtocollo=cc.toString();
      }
      this.registriCaricoScarico.settaField('registroRentri2','')
      console.log("saving in all events ",e);
     // e.changes[0]['data']['numeroultimoprotocollo']="1";

    }
    //
  }

  close(){
    alert("Chiudooooooooooo","chiudooooooo");
    //
  }
}
